import React from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface LegalRepresentationCheckboxProps {
  value: boolean;
  onChange: (value: boolean) => void;
  disabled: boolean;
}

export default function LegalRepresentationCheckbox({
  value,
  onChange,
  disabled,
}: LegalRepresentationCheckboxProps) {
  const { t } = useTranslation();

  return (
    <FormControlLabel
      id='legalRepresentationCheckboxLegalRepresentationInputLabelOption'
      control={
        <Checkbox
          id='legal-representation-checkbox'
          checked={value}
          onChange={(e) => onChange(e.target.checked)}
          disabled={disabled}
        />
      }
      label={t('formInputs.legalRepresentationInputLabel')}
    />
  );
}
